import { useState } from "react";
import { S, brandColor, brandFromSlug, timeAgo, FLAIRS } from "../data/constants";

export function Badge({ text, bg="#f0f0f0", color="#1a1a1a" }) {
  return <span style={{ fontSize:10, fontWeight:700, letterSpacing:1.5, textTransform:"uppercase", padding:"2px 8px", background:bg, color, borderRadius:3, fontFamily:"'Geist',sans-serif", marginLeft:6 }}>{text}</span>;
}

export function Avatar({ name="?", size=36, color="#262626", emoji=null }) {
  // Si hay emoji lo mostramos, si no, iniciales (primera letra de cada palabra, máx 2)
  const words = (name||"?").trim().split(/\s+/);
  const i = words.length >= 2
    ? (words[0][0] + words[words.length-1][0]).toUpperCase()
    : (words[0].slice(0,2)).toUpperCase();
  return <div style={{ width:size, height:size, borderRadius:"50%", background:color, color:"#fff", display:"flex", alignItems:"center", justifyContent:"center", fontSize:emoji?size*0.5:size*0.35, fontWeight:700, flexShrink:0, fontFamily:"'Geist',sans-serif", letterSpacing:-0.5 }}>{emoji||i}</div>;
}

export function Spinner() {
  return <div style={{ textAlign:"center", padding:40, color:"#888", fontFamily:"'Geist',sans-serif", fontSize:13 }}>Cargando…</div>;
}

export function Logo({ height=36, withName=true }) {
  // logo-header en vez de logo.png: el original mide 1254px y pesaba 850 KB
  // para pintarse a 36-60px de alto, y se descargaba en cada carga. Este pesa
  // 21 KB. El grande se queda sólo para og:image al compartir en redes.
  // Sin loading="lazy": va en la cabecera, siempre visible desde el principio,
  // y diferirlo sólo provocaba que apareciera con retraso.
  // El nombre va como texto y no incrustado en el PNG: así se lee a cualquier
  // tamaño y renombrar la marca no obliga a rehacer la imagen.
  return (
    <div style={{ display:"inline-flex", alignItems:"center", gap:Math.round(height*0.2) }}>
      <img src="/logo-header.png" height={height} alt="Wwatch" style={{ display:"block" }} />
      {withName && (
        <span style={{ fontFamily:"'Geist',sans-serif", fontWeight:800, fontSize:Math.round(height*0.52), letterSpacing:-0.5, color:"#141b34", lineHeight:1 }}>Wwatch</span>
      )}
    </div>
  );
}

export function FlairBadge({ flair }) {
  const f = FLAIRS.find(fl=>fl.id===flair) || FLAIRS[0];
  return <span style={{ fontSize:10, fontWeight:700, letterSpacing:1, textTransform:"uppercase", padding:"2px 8px", background:f.bg, color:f.color, borderRadius:20, fontFamily:"'Geist',sans-serif", marginRight:6 }}>{f.label}</span>;
}

export function StarRating({ value, onChange, size=20, readonly=false }) {
  const [hover, setHover] = useState(0);
  return (
    <div style={{ display:"flex", gap:2 }}>
      {[1,2,3,4,5].map(i=>(
        <span key={i} style={{ fontSize:size, cursor:readonly?"default":"pointer", color:i<=(hover||value)?"#f59e0b":"#e2e8f0", lineHeight:1 }}
          onClick={()=>!readonly&&onChange&&onChange(i)}
          onMouseEnter={()=>!readonly&&setHover(i)}
          onMouseLeave={()=>!readonly&&setHover(0)}>★</span>
      ))}
    </div>
  );
}

export function WatchCard({ watch, onClick, size="normal" }) {
  const bg = brandColor(watch.slug);
  const [imgError, setImgError] = useState(false);
  const h = size==="large" ? 160 : 110;
  return (
    <div style={{ cursor:"pointer", borderRadius:10, overflow:"hidden", border:"1px solid #e5e5e5", background:"#fff", boxShadow:"0 2px 8px rgba(0,0,0,0.06)", transition:"transform 0.15s, box-shadow 0.15s" }}
      onClick={onClick}
      onMouseEnter={e=>{ e.currentTarget.style.transform="translateY(-2px)"; e.currentTarget.style.boxShadow="0 6px 20px rgba(0,0,0,0.12)"; }}
      onMouseLeave={e=>{ e.currentTarget.style.transform="translateY(0)"; e.currentTarget.style.boxShadow="0 2px 8px rgba(0,0,0,0.06)"; }}>
      <div style={{ height:h, background:`linear-gradient(135deg, ${bg}, ${bg}cc)`, display:"flex", alignItems:"center", justifyContent:"center", position:"relative", overflow:"hidden" }}>
        {watch.image_url && !imgError ? (
          <img loading="lazy" src={watch.image_url} alt={watch.model} style={{ height:"90%", objectFit:"contain", filter:"drop-shadow(0 4px 12px rgba(0,0,0,0.3))" }} onError={()=>setImgError(true)} />
        ) : (
          <div style={{ textAlign:"center" }}>
            <div style={{ fontSize:size==="large"?32:22, marginBottom:4 }}>⌚</div>
            <div style={{ fontFamily:"'Geist',sans-serif", fontSize:size==="large"?15:12, color:"#fff", fontWeight:700 }}>{watch.model}</div>
          </div>
        )}
        <div style={{ position:"absolute", top:8, left:8, background:"rgba(0,0,0,0.4)", borderRadius:4, padding:"2px 8px", fontFamily:"'Geist',sans-serif", fontSize:9, color:"rgba(255,255,255,0.8)", letterSpacing:1.5, textTransform:"uppercase" }}>{brandFromSlug(watch.slug)}</div>
      </div>
      <div style={{ padding:"12px 14px" }}>
        <div style={{ fontWeight:700, fontSize:size==="large"?15:13, marginBottom:2 }}>{watch.model}</div>
        <div style={{ fontFamily:"'Geist',sans-serif", fontSize:10, color:"#aaa", marginBottom:4 }}>Ref. {watch.reference}</div>
        <div style={{ fontSize:10, color:"#c8a84b", fontFamily:"'Geist',sans-serif" }}>@{watch.slug}</div>
      </div>
    </div>
  );
}
